import React from 'react';

import { Block, withConfig } from '../common/Block.jsx';
import { Clickable, Hoverable, withTokenParsing } from '../common/Button.jsx';
import { Column, Container, Row, Spaced } from '../common/Container.jsx';
import Defaults from '../layout/Defaults.jsx';
import { FormButton, FormContainer, SuccessMessage as FormSuccessMessage, withSubscriptionLogging, withValidationV2 } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { Required, Wrapper as InputWrapper } from '../common/Input.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';

// region ARTIST SIGNUP V1 (-- DEPRECATED Use `ArtistSignupV2` --)

function _ArtistSignupV1Component(props) {
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            ArtistId: props.data.id || props.data.artistId,
            Email: props.formData.Email,
            Name: props.formData.Name,
            Robots: props.formData.token,
            Sub: props.config.subdomain
        }
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        props.onSubmit('/api/subscriptions/artists', postData);
    }, [props.formData.token])
    const buttonClassName = props.formData.formState != undefined ? ` btn--${props.formData.formState}` : '';
    const disabled = props.builder == true || props.disabled == true || props.formData.formState != undefined;
    let buttonHoverProps, buttonSpacing, buttonStyle, inputClassName, inputSpacing, inputStyle;
    if (props.blockConfig) {
        if (props.blockConfig.button) {
            buttonStyle = {};
            Block.mapStyleConfigProps(buttonStyle, props.blockConfig.button, (propName, propValue, propUnit) => {
                let _propValue = propValue;
                if (_propValue && propUnit) {
                    _propValue = `${_propValue}${propUnit}`;
                }
                switch (propName) {
                    case 'lineSpacing':
                        buttonSpacing = _propValue;
                        return true;
                    default:
                        if (propName.indexOf('Hover') < 0 || !_propValue) {
                            break;
                        }
                        if (!buttonHoverProps) {
                            buttonHoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        buttonHoverProps[_propName] = _propValue;
                        return true;
                }
            });
        }
        if (props.blockConfig.input) {
            inputStyle = {};
            Block.mapStyleConfigProps(inputStyle, props.blockConfig.input, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'inputStyle':
                        inputClassName = `input--${propValue}`
                        return true;
                    case 'lineSpacing':
                        if (propValue && propUnit) {
                            inputSpacing = `${propValue}${propUnit}`;
                        }
                        return true;
                }
            });
        }
    }
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    if (props.builder || props.disabled) {
        layoutStyles.style.pointerEvents = 'none';
    }
    let className = 'form form--contact form--whitelabel__v1';
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let ButtonComponent = Clickable;
    if (buttonHoverProps != undefined) {
        ButtonComponent = Hoverable;
    }
    const EmailInput = (
        <InputWrapper size="small">
            <Required
                className={inputClassName}
                disabled={disabled}
                errors={props.formData.errors}
                name="Email"
                placeholder="Email Address *"
                style={inputStyle}
                type="email"
                value={props.formData.Email}
                onChange={props.onChange} />
        </InputWrapper>
    );
    const NameInput = (
        <InputWrapper size="small">
            <Required
                className={inputClassName}
                disabled={disabled}
                errors={props.formData.errors}
                name="Name"
                placeholder="Full Name *"
                style={inputStyle}
                value={props.formData.Name}
                onChange={props.onChange} />
        </InputWrapper>
    );
    const SubmitButton = (
        <ButtonComponent
            className={`btn btn--fill btn--sm form__btn${buttonClassName}`}
            disabled={disabled}
            hoverProps={buttonHoverProps}
            style={buttonStyle}
            type="submit"
            onClick={props.onValidate}>
            <React.Fragment><div className="submission-status" /> {props.formData.formState == 'success' ? 'Artist Followed' : 'Follow Artist'}</React.Fragment>
        </ButtonComponent>
    );
    if (props.legacy) {
        return (
            <Container>
                <Spaced large={true}>
                    <Row>
                        <Column className="col--push--3 col--xs--push--0" size="6">
                            <form className="form form--contact">
                                <Row>
                                    <Column size="12">
                                        {NameInput}
                                    </Column>
                                    <Column size="12">
                                        {EmailInput}
                                    </Column>
                                    <Column size="12">
                                        <div className="form--contact__foot">
                                            {SubmitButton}
                                        </div>
                                    </Column>
                                </Row>
                            </form>
                        </Column>
                    </Row>
                </Spaced>
            </Container>
        );
    }
    let content = (
        <form className={className} style={layoutStyles.style}>
            <div className="form__inn" style={{ marginBottom: inputSpacing }}>
                {NameInput}
            </div>
            <div className="form__inn">
                {EmailInput}
            </div>
            <div className="form--sub__inn" style={{ marginTop: buttonSpacing }}>
                {SubmitButton}
            </div>
        </form>
    );
    if (layoutStyles.containerStyle) {
        if (layoutStyles.containerStyle.maxWidth) {
            layoutStyles.containerStyle.width = '100%';
        }
        content = <div className="form--container cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    if (props.onContent) {
        content = props.onContent(content)
    }
    return content;
}
const ArtistSignupV1Component =
    withConfig(
        withSubscriptionLogging(
            withValidationV2(
                _ArtistSignupV1Component,
                ['Email', 'Name']
            ),
            'artist'));
const ArtistSignupV1 = { Component: ArtistSignupV1Component };

// region ARTIST SIGNUP V2

function _ArtistSignupV2Component(props) {
    React.useEffect(() => {
        if (!props.formData.token) {
            return;
        }
        const postData = {
            ArtistId: props.data.id || props.data.artistId,
            Email: props.formData.Email,
            Name: props.formData.Name,
            Robots: props.formData.token,
            Sub: props.config.subdomain
        }
        if (window && window.cookie) {
            postData.Referrer = cookie.getCookie(cookie._referrer);
            postData.Utm = cookie.getCookie(cookie._utm);
        }
        props.onSubmit('/api/subscriptions/artists', postData);
    }, [props.formData.token])
    const handleFormFieldProps = React.useCallback(({ type }, formFieldProps) => {
        switch (type) {
            case FormField.Email:
                formFieldProps.placeholderText = 'Email Address *';
                formFieldProps.type = 'email';
                formFieldProps.onSubmit = props.onValidate;
                break;
            case FormField[Name.Block.Artist.Signup.Container].ErrorMessage:
                formFieldProps.editor = props.editor;
                formFieldProps.error = props.formData.errorMessage;
                break;
            case FormField.Name:
                formFieldProps.placeholderText = 'Full Name *';
                formFieldProps.onSubmit = props.onValidate;
                break;
            case FormField[Name.Block.Artist.Signup.Container].SubmitButtonV1:
            case FormField[Name.Block.Artist.Signup.Container].SubmitButtonV2:
                formFieldProps.artist = props.data && props.data.artist;
                formFieldProps.formState = props.formData.formState;
                formFieldProps.onClick = props.onValidate;
                break;
            case FormField[Name.Block.Artist.Signup.Container].SuccessMessage:
                formFieldProps.artist = props.data && props.data.artist;
                formFieldProps.editor = props.editor;
                formFieldProps.formState = props.formData.formState;
                break;
        }
    }, [props.formData.errorMessage, props.formData.formState]);
    let contentConfig = props.contentConfig;
    if (!contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.design && props.blockConfig.layout.design.desktop && props.blockConfig.layout.design.desktop.blocks && props.blockConfig.layout.design.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.design;
        } else {
            contentConfig = Defaults.Block[Name.Block.Artist.Signup.Container];
        }
    }
    return (
        <FormContainer.Component
            {...props}
            contentConfig={contentConfig}
            onFormFieldProps={handleFormFieldProps} />
    );
}
const ArtistSignupV2Component =
    withSubscriptionLogging(
        withValidationV2(
            _ArtistSignupV2Component,
            ['Email', 'Name']
        ),
        'artist');
const ArtistSignupTokens = () => {
    return [
        { display: 'Artist Name', token: Token.ArtistName }
    ];
}
const ArtistSignupV2 = { Component: ArtistSignupV2Component, Tokens: ArtistSignupTokens };

// region SUBMIT BUTTON

const SubmitButtonV1Component = withTokenParsing(FormButton.V1, (data, keyword) => {
    switch (keyword) {
        case Token.ArtistName:
            return data.name;
    }
});
const SubmitButtonV2Component = withTokenParsing(FormButton.V2, (data, keyword) => {
    switch (keyword) {
        case Token.ArtistName:
            return data.name;
    }
});
const SubmitButton = { V1: SubmitButtonV1Component, V2: SubmitButtonV2Component };

// region SUCCESS MESSAGE

const SuccessMessageComponent = Token.withContentTokenParsing(FormSuccessMessage.Component, {}, (props, keyword, options) => {
    const data = props.data ? { ...props.data } : {};
    data.wrapContent = false;
    return Token.parsing.artist(data, keyword, options);
});
const SuccessMessage = { Component: SuccessMessageComponent };

export {
    ArtistSignupV2,
    SubmitButton,
    SuccessMessage,

    // DEPRECATED
    ArtistSignupV1
}